import networkAdapter from '../adapters/network';

export const fetchOwnedFarms = ({ userId }) => {
  const legacyOptions = {
    url: `/api/v5/farms/owned?userId=${userId}`,
    userId,
    isPagedData: true
  };
  
  return networkAdapter({
    legacyOptions
  });
};

export const fetchSharedFarms = ({ userId }) => {
  const legacyOptions = {
    url: `/api/v5/farms/accessible`,
    userId,
    isPagedData: true
  };
  
  return networkAdapter({
    legacyOptions
  });
};


